export default JSON.stringify({
  data: {
    requested: 'success',
  },
})
